export const PORTRAIT_REQUEST = 'portrait/PORTRAIT_REQUEST';
export const PORTRAIT_SUCCESS = 'portrait/PORTRAIT_SUCCESS';
